module.exports = __webpack_public_path__ + "static/media/DSC01462.f2654a67.jpg";